module.exports = __webpack_public_path__ + "media/application/images/svgs/blob-3-0c8bc20c7f02bc5781aa83f02adf66f3.svg";